// Fucntion to get the current screen when thw redux state is not updated or being null or undefined or an empty string

function getCurrentScreen(screen: string | null | undefined, isAdmin: boolean, isManager: boolean, isStaff: boolean): string {
    // if screen is null or undefined or empty string, return based on the user type
    let currentScreen: string;
    if (screen === null || screen === undefined || screen === "") {
        if (isAdmin) {
            currentScreen = "Admin";
        } else if (isManager) {
            currentScreen = "Manager";
        } else if (isStaff) {
            currentScreen = "Staff";
        } else {
            currentScreen = "Staff"; // default to Staff
        }
    }
    else {
        currentScreen = screen;
    }
    return currentScreen;
}

export default getCurrentScreen;